{
  "version": 1,
  "asset_id": "f793060c-e2db-4778-b6be-91873a4681e6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f793060c-e2db-4778-b6be-91873a4681e6/wordmark-400.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f793060c-e2db-4778-b6be-91873a4681e6/wordmark-400.webp",
  "original_filename": "wordmark-400.webp",
  "size": 15432,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:19:11Z"
}
